var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-4"},[_c('h1',[_vm._v("aggrid表格封装")]),_c('VritualGrid',{ref:"grid",staticClass:"pa-1",staticStyle:{"height":"600px"},attrs:{"a":"1","b":"2","c":"3","styles":"height: 100px;border: 1px solid lightblue;","column-defs":_vm.columnDefs,"row-data":_vm.rowData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }